<template>
  <section class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col s12 m4">
          <div class="social left">
            <div class="pcg-footer-contact-table">
              <div class="links-logo pb4">
                <div>
                  <a href="http://www.infrastructure-ni.gov.uk/" target="_blank"><img src="@/assets/images/Belfast/Footer/Infra.png" alt="" /></a>
                  <br/>
                  <p class="pcg-footer-copyright">Have feedback for the proposed changes? <a href="" target="_blank">Leave Feedback</a></p>
                </div>
                
              </div>
              <div class="links-logo">
                <div class="grow-50">
                  <p><a href="https://www.translink.co.uk/usingtranslink/introducingglider" target="_blank"><img src="@/assets/images/Belfast/Footer/Glider.png" alt="" /></a></p>
                </div>
                <div class="grow-50">
                  <p><a href="https://www.translink.co.uk/" target="_blank"><img src="@/assets/images/Belfast/Footer/Translink.png" alt="" /></a></p>
                </div>
                
              </div>
              <div class="links-logo pb4">
                <div class="grow-20 gap-after">
                  <p class="pcg-footer-copyright"><a href="privacyPage" class="footer-link">Privacy Policy</a></p> 
                </div>
                <div class="grow-20 gap-after">
                  <p class="pcg-footer-copyright"><a href="cookiesPage" class="footer-link">Cookies Policy</a></p> 
                </div>
              </div>
              <div class="pcg-footer-copyright">
                © Copyright 2021 Department of Infrastructure. All Rights Reserved.
              </div>
            </div>
          </div>
          
        </div>
        <div class="col s12 m8">
          <div class="social">
            <div class="pcg-footer-text right">
              <p><a href="homePage">Home</a></p>
              <p><a href="gliderPhasePage">Glider Phase 2</a></p>
              <p><a href="optionsPage">Phase 2 Options</a></p>
              <p><a href="webinarPage">Webinar</a></p>
              <p><a href="faqPage">Frequently Asked Questions</a></p>
              <p><a href="map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback">Have Your Say</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "site-footer",
};
</script>
